export default {"src":"/_next/static/media/identity-verified.5c358936.svg","height":20,"width":17,"blurWidth":0,"blurHeight":0};